import { Injectable } from "@angular/core";
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot
} from "@angular/router";
import { AuthenticationService } from "@appcore/service";

/**
 * An authorization guard that protects pages from users not properly authenticated and logged in.
 *
 * @author    John Ying <john.ying@childrenshospitals.org>
 * @created   8/31/2023
 */
@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
	constructor(private router: Router, private authenticationService: AuthenticationService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		AuthenticationService.redirectUrl = state.url;
		return this.authenticationService.isAuthenticated();
	}
}
